import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'

import PharmacySearchContainer from '../../../containers/PharmacySearchContainer'
import withDialog from '../../../hoc/withDialog'
import { objectIdPropTypeRequired } from '../../../proptypes/helpers/object-id'
import TestIds from '../../../util/TestIds'
import AngleLeftIcon from '@ui-components-3/icons/lib/solid/AngleLeft'
import DialogHeader from '../../common/DialogHeader'

const PharmacySearchDialog = ({ onPharmacyAdded, onClose, ...props }) => {
  const [resultsCount, setResultsCount] = useState(0)

  const onSearchSuccess = useCallback((count) => {
    setResultsCount(count || 0)
  }, [])

  return (
    <PharmacySearchContainer
      {...props}
      onSelectionMade={onPharmacyAdded}
      header={
        <div className="px-4 py-4 md:px-6">
          <DialogHeader
            title="Add a Pharmacy"
            titleTestId={TestIds.newVisit.label.addPharmacyTitle}
            onClose={onClose}
            closeButtonTestId={TestIds.newVisit.button.cancelAddPharmacy}
          />
          {!!resultsCount && (
            <div className="mt-4 flex items-center">
              <button
                className="btn-small btn-neutral-borderless text-primary-600 h-6 px-0"
                type="button"
                onClick={() => setResultsCount(0)}
              >
                <AngleLeftIcon className="h-6 w-6" aria-hidden="true" />
                Back
              </button>
              <span className="mx-3 h-6 w-px bg-neutral-300" />
              <span className="typography-body-l font-normal text-neutral-600">Found: {resultsCount} Pharmacies</span>
            </div>
          )}
        </div>
      }
      onBackdropClick={onClose}
      maxWidth={'sm'}
      contentClass="!px-0 !pt-0 !pb-0"
      onSearchSuccess={onSearchSuccess}
      showResults={!!resultsCount}
    />
  )
}

PharmacySearchDialog.propTypes = {
  memberId: objectIdPropTypeRequired,
  onPharmacyAdded: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default withDialog(PharmacySearchDialog)
